import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              APP下载
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
              {appData.title}
            </h2>
            <p className="text-lg text-foreground-600 mt-3">{appData.subtitle}</p>
            <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
              {appData.desc}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
              {appData.features.map((feature) => (
                <div
                  key={feature}
                  className="flex items-center gap-2 px-3 py-2 bg-background-50 border border-background-200 rounded-lg"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">{feature}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4 mt-8">
              <button className="px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-apple-fill mr-2"></i>
                App Store
              </button>
              <button className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-google-play-fill mr-2"></i>
                Google Play
              </button>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative flex items-center gap-6">
              <div className="hidden sm:block w-40 h-40 bg-background-50 border-2 border-background-200 rounded-xl p-3">
                <img
                  src={appData.qrImage}
                  alt="扫码下载拷贝漫画APP"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="w-44 sm:w-52">
                <img
                  src={appData.appImage}
                  alt="拷贝漫画APP界面"
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}